import React from 'react';
import { MdDelete, MdEdit } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { Tooltip, Whisper } from 'rsuite';
import { optimizationPricesResultSelector } from '../../../../../../../reducers/OtimizacaoPrecos';
import { toggleModal } from '../../../../../../../reducers/OtimizacaoPrecos/optimizationPricesList';
import { Header } from '../../../OtimizacaoPrecos/components/Header';
import { ModalConfirmAction } from '../../../OtimizacaoPrecosLista/components/ModalConfirmAction';
import styles from './HeaderResult.module.scss';

export const HeaderResult = () => {
  const history = useHistory();
  const { id } = useParams() as Record<'id', string>;

  const { header, result } = useSelector(optimizationPricesResultSelector);
  const { status } = header;
  const dispatch = useDispatch();
  const MemoModalConfirmAction = React.memo(ModalConfirmAction);

  const showEditButton = result?.status === 'ativa';

  const handleDelete = () => {
    dispatch(toggleModal({ name: 'delete', id: id.toString() }));
  };

  return (
    <>
      <Header badge={status} title="Resultado da Otimização">
        <div className={styles.buttons}>
          <button
            className={styles['main-button']}
            onClick={() => {
              window.open('/ipa/gerenciador-de-precos', '_blank');
            }}
          >
            Gerenciar preços
          </button>
          {showEditButton && (
            <button
              onClick={() => {
                history.push(`/ipa/ia/otimizacao-de-precos/${id}`);
              }}
            >
              <Whisper placement="top" trigger="hover" speaker={<Tooltip>Editar otimização</Tooltip>}>
                <MdEdit style={{ height: '20px', width: '20px', color: '#959595' }} />
              </Whisper>
            </button>
          )}
          <button onClick={handleDelete}>
            <Whisper placement="top" trigger="hover" speaker={<Tooltip>Excluir</Tooltip>}>
              <MdDelete style={{ height: '20px', width: '20px', color: '#959595' }} />
            </Whisper>
          </button>
        </div>
      </Header>
      <MemoModalConfirmAction redirectPath="/ipa/ia/otimizacao-de-precos/lista" />
    </>
  );
};
